module.exports = __webpack_public_path__ + "static/Q3Answer2_Burgers_IlyaMashkov-ecc2d42408ec2d769be9792bb89751a0.jpg";